import { cn } from "@/lib/utils";

/**
 * Estilo común de los triggers de la barra de filtros (Select, multi-select,
 * rangos numéricos y de fechas): fondo claro con borde en reposo y azul suave
 * («subtle») cuando el filtro tiene un valor activo.
 */
export function filterTriggerClass(active: boolean) {
  return cn(
    "h-control text-control rounded-md border font-normal opacity-100 [&_svg]:opacity-80 shadow-none hover:shadow-none dark:shadow-none dark:hover:shadow-none transition-colors",
    active
      ? // Colores de la variante «subtle» del botón, con el fondo más claro.
        "border-primary/15 bg-primary/10 text-primary data-[placeholder]:text-primary hover:bg-primary/15 hover:text-primary [&_svg:not([class*='text-'])]:text-primary dark:border-primary/25 dark:bg-primary/20 dark:text-primary-100/80 dark:hover:bg-primary/30"
      : "border-input bg-background text-foreground/80 data-[placeholder]:text-foreground/80 hover:bg-muted/60 hover:text-foreground dark:border-zinc-800 dark:bg-zinc-800/40 dark:hover:bg-zinc-800/70",
  );
}
